import Image from "next/image";

const SomethingWentWrong = ({ children }: { error?: Error; children: React.ReactNode }) => {
	return (
		<section className="relative py-16 md:py-20 lg:py-24">
			<div className="pb-12 md:pb-14 lg:pb-20">
				<div className="mx-auto max-w-[900px] text-center">
					<Image
						src="/images/500-illustration.svg"
						alt="Something went wrong, please retry in a while - PropTechBuzz"
						width={1080}
						height={1080}
					/>
				</div>
				<div className="pt-10 text-center text-2xl font-bold sm:text-3xl md:pt-16 md:text-4xl lg:pt-20 lg:text-5xl">
					Oops! Something Went Wrong
				</div>
				<p className="pt-4 text-center text-base text-[#738296] md:pt-5 md:text-lg">
					Oh no! We hit a snag. Our team is hard at work fixing the issue that caused this error
				</p>
				{children}
			</div>
		</section>
	);
};

export default SomethingWentWrong;
